		//TOPページ背景用
		function beforeSlide(i) {
			let winW = $(window).width();
			let winH = $(window).height();

			if (i == 0) {
				TweenLite.to($(".slide_img0"), 8, { scale: 1.05, ease: Power0.easeNone, force3D: false });
			} else if (i == 1) {
				var lw = winW / 30;
				TweenLite.to($(".slide_img1"), 0, { scale: 1.05, x: lw });
				TweenMax.to($(".slide_img1"), 8, { x: -lw, ease: Power0.easeNone, force3D: false });
			} else if (i == 2) {
				var lh = winH / 20;
				TweenLite.to($(".slide_img2"), 0, { scale: 1.05, y: -lh });
				TweenMax.to($(".slide_img2"), 8, { y: lh, ease: Power0.easeNone, force3D: false });
			}
		}

		function afterSlide() {
			BackgroundCheck.refresh();
		}

		$(window).on('load', function () {
			"use strict";

			//SPナビ
			$('#btnMenu').click(function () {
				$('body').toggleClass('openMenu');
			});

			//スライダー
			if ($('.slider').length) {
				//slider
				$('.slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
					var i = (currentSlide ? currentSlide : 0) + 1;
					$('.slick-num .nowcnt').text(i);
					$('.slick-num .allcnt').text(slick.slideCount);
				});

			var sliderOpt = {
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		lazyLoad: 'progressive',
		prevArrow: '<div class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_detail_prev.png?v=1626080185" alt="PREV"></div>',
		nextArrow: '<div class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_detail_next.png?v=1626080185" alt"NEXT"></div>',
		responsive: [{
			breakpoint: 749,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true
			}
		}]
	};
	var slider = $('.slider').slick(sliderOpt);


	// スマホで全てのスライドのwidthをリセット（動画含む）
	slider.on('init reInit afterChange', function(event, slick){
		if ($(window).width() < 749) {
			$('.slider .slick-slide').each(function(){
				$(this).css('width', '100%');
			});
		}
	});

	// 初期化時にも実行
	if ($(window).width() < 749) {
		$('.slider .slick-slide').css('width', '100%');
	}
	}

			//INDEX
			if ($('#index').length) {
				//背景
				$('<img>').attr('src', 'https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_bg_top_20260420.jpg').on('load', function () {

					$('#MainContent .banner').backstretch([
						'https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_bg_top_20260420.jpg',
						'https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_bg_top2.jpg',
						'https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_bg_top3.jpg'
					], {
						duration: 5000,
						fade: 2000,
						before: 'beforeSlide',
						after: 'afterSlide'
					});


				});
				let winH = $(window).height();
				$('#MainContent .banner').height(winH);

				//PRODUCT
				//slider
				var topProductSliderOpt = {
					autoplay: false,
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: false,
					lazyLoad: 'progressive',
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							centerMode: true,
							centerPadding: '84px'
						}
					}]
				};
				var topProductSlider = $('.home-product-slider').slick(topProductSliderOpt);


				let winWidth = $(window).width();
				let moviePC = $('#moviePC');
				let movieSP = $('#movieSP');
				if (winWidth < 768) {
					movieSP.attr('src', movieSP.data('src'));
					moviePC.hide();
					//console.log('SP');
				} else {
					moviePC.attr('src', moviePC.data('src'));
					movieSP.hide();
					//console.log('PC');
				}

			}

			//COLLECTION
			if ($('#collection').length) {

				//すべての商品でなければ、ヘッダー画像省略
				let hash = location.search;
				if (location.pathname != "/collections/all" || hash.match(/page=/)) {
					var position = $('#mainArea').offset().top + 2;
					$("html, body").animate({ scrollTop: position }, 0);
				}

				//SIZEボタン
				var proSize = $('.proSize'),
					proSizeBtn = proSize.find('.proSizeBtn'),
					proSizeClose = proSize.find('.proSizeClose'),
					proSizeInfo = proSize.find('.proSizeInfo'),
					proSizeItem = proSize.find('.proSizeItem');

				proSizeBtn.click(function () {
					if (proSize.hasClass('on')) return;
					proSize.addClass('on');
					proSizeInfo.slideDown();
				});

				proSizeClose.click(function () {
					proSize.removeClass('on');
					proSizeInfo.slideUp();
				});

				//タグデータ収集
				let cat01 = [];
				$('.searNo1 .option').not('.all').find('a').each(function (index, element) {
					cat01.push($(this).attr('href'));
				});
				let cat02 = [];
				$('.searNo2 .option').not('.all').find('a').each(function (index, element) {
					cat02.push($(this).attr('href'));
				});
				let cat03 = [];
				$('.searNo3 .option').not('.all').find('a').each(function (index, element) {
					cat03.push($(this).attr('href'));
				});
				let cat04 = [];
				$('.searNo4 .option').not('.all').find('a').each(function (index, element) {
					cat04.push($(this).attr('href'));
				});
				let cat05 = [];
				$('.searNo5 .option').not('.all').find('a').each(function (index, element) {
					cat05.push($(this).attr('href'));
				});
				let cat06 = [];
				$('.searNo6 .option').not('.all').find('a').each(function (index, element) {
					cat06.push($(this).attr('href'));
				});
				//PICKUP在庫商品確認用
				let cat07 = ['in-stock'];
				//console.log(cat06);

				//URLにタグが含まれているかをチェック
				let now = location.pathname;//現在置
				let tag = [];//URLに含まれているタグ
				let nowSelect = [];//表示リスト用配列
				let nowCat = [];//URL第2階層

				//タグ一覧表示用　------------------------------------------
				if (now == "/collections/all" || now == "/collections/all/") {
					//「すべての商品」であれば、tagをリセットして、表示リストに「全て」を追加
					tag = [];
					nowSelect.push('全て');
					nowCat = "all";
				} else {
					//「タグ」であれば、tagをリセット
					tag = [];
					//URLからタグ以外の要素を削除
					if (now.includes("/collections/all")) {
						now = now.replace("/collections/all/", "");
						nowCat = "all";
					} else {
						now = now.replace("/collections/", "");
						//コレクションがあれば、文字列を取得
						nowCat = now.split("/");
						nowCat = nowCat[0];
						//コレクションをタグリストに表示
						nowSelect.push(nowCat);
						//URLからコレクション名を削除
						now = now.replace(nowCat, "");
						now = now.replace("/", "");
					}
					//URLデコード
					if (now != "") {
						now = decodeURI(now);
					}

					if (now.includes("+")) {
						//タグが複数あった場合
						tag = now.split("+");
						for (let i = 0; i < tag.length; i++) {
							nowSelect.push(tag[i]);
						}
					} else {
						if (now != "") {
							tag.push(now);
							nowSelect.push(tag[0]);
						}
					}
				}
				//タグリスト表示追加
				$('#nowSelect').html('<ul class="nowSelect"></ul>');
				for (let i = 0; i < nowSelect.length; i++) {
					//タグにALLがあれば削除
					if (nowSelect[i].includes('ALL')) {
						nowSelect[i] = nowSelect[i].replace("ALL", "");
					}
					//全角スラッシュを半角スラッシュして表示
					nowSelect[i] = nowSelect[i].replace("／", "/");
					//サイズが「全て」の場合は、「ALL」を追加して表示
					if (nowSelect[i] == "WIDTH") {
						nowSelect[i] = nowSelect[i] + " ALL";
					}
					if (nowSelect[i] == "DEPTH") {
						nowSelect[i] = nowSelect[i] + " ALL";
					}
					if (nowSelect[i] == "HEIGHT") {
						nowSelect[i] = nowSelect[i] + " ALL";
					}
					$('#nowSelect .nowSelect').append('<li>' + nowSelect[i] + '</li>');
				}

				//フィルタークリック　------------------------------------------
				let tag01 = "";
				let tag02 = "";
				let tag03 = "";
				let tag04 = "";
				let tag05 = "";
				let tag06 = "";
				let tag07 = "";

				//現在のタグをカテゴリに振り分け
				for (let i = 0; i < tag.length; i++) {
					if (cat01.includes(tag[i])) {
						//console.log(tag[i] + 'はcat01に含んでます');
						tag01 = tag[i];
					}
					if (cat02.includes(tag[i])) {
						//console.log(tag[i] + 'はcat02に含んでます');
						tag02 = tag[i];
					}
					if (cat03.includes(tag[i])) {
						//console.log(tag[i] + 'はcat03に含んでます');
						tag03 = tag[i];
					}
					if (cat04.includes(tag[i])) {
						//console.log(tag[i] + 'はcat04に含んでます');
						tag04 = tag[i];
					}
					if (cat05.includes(tag[i])) {
						//console.log(tag[i] + 'はcat05に含んでます');
						tag05 = tag[i];
					}
					if (cat06.includes(tag[i])) {
						//console.log(tag[i] + 'はcat06に含んでます');
						tag06 = tag[i];
					}
					if (cat07.includes(tag[i])) {
						//console.log(tag[i] + 'はcat07に含んでます');
						tag07 = tag[i];
					}
				}

				$('.searNo1 a').click(function () {
					//受け皿を初期化
					tag01 = "";
					//クリックされたhrefを取得
					let url = $(this).attr('href');
					if (url == "all") {
						tag01 = "";
					} else {
						tag01 = url;
					}
					gotoURL(tag01, tag02, tag03, tag04, tag05, tag06, tag07);
					return false;
				});
				$('.searNo2 a').click(function () {
					//受け皿を初期化
					tag02 = "";
					//クリックされたhrefを取得
					let url = $(this).attr('href');
					if (url == "all") {
						tag02 = "";
					} else {
						tag02 = url;
					}
					gotoURL(tag01, tag02, tag03, tag04, tag05, tag06, tag07);
					return false;
				});
				$('.searNo3 a').click(function () {
					//受け皿を初期化
					tag03 = "";
					//クリックされたhrefを取得
					let url = $(this).attr('href');
					if (url == "all") {
						tag03 = "";
					} else {
						tag03 = url;
					}
					gotoURL(tag01, tag02, tag03, tag04, tag05, tag06, tag07);
					return false;
				});
				$('.searNo4 a').click(function () {
					//受け皿を初期化
					tag04 = "";
					//クリックされたhrefを取得
					let url = $(this).attr('href');
					if (url == "all") {
						tag04 = "";
					} else {
						tag04 = url;
					}
					gotoURL(tag01, tag02, tag03, tag04, tag05, tag06, tag07);
					return false;
				});
				$('.searNo5 a').click(function () {
					//受け皿を初期化
					tag05 = "";
					//クリックされたhrefを取得
					let url = $(this).attr('href');
					if (url == "all") {
						tag05 = "";
					} else {
						tag05 = url;
					}
					gotoURL(tag01, tag02, tag03, tag04, tag05, tag06, tag07);
					return false;
				});
				$('.searNo6 a').click(function () {
					//受け皿を初期化
					tag06 = "";
					//クリックされたhrefを取得
					let url = $(this).attr('href');
					if (url == "all") {
						tag06 = "";
					} else {
						tag06 = url;
					}
					gotoURL(tag01, tag02, tag03, tag04, tag05, tag06, tag07);
					return false;

				});

				//遷移
				function gotoURL(tag01, tag02, tag03, tag04, tag05, tag06, tag07) {
					let nextURL = "/collections/" + nowCat + "/";

					if (tag01 != "") {
						nextURL = nextURL + tag01;
						if (tag02 != "") {
							tag02 = "+" + tag02;
							nextURL = nextURL + tag02;
						}
						if (tag03 != "") {
							tag03 = "+" + tag03;
							nextURL = nextURL + tag03;
						}
						if (tag04 != "") {
							tag04 = "+" + tag04;
							nextURL = nextURL + tag04;
						}
						if (tag05 != "") {
							tag05 = "+" + tag05;
							nextURL = nextURL + tag05;
						}
						if (tag06 != "") {
							tag06 = "+" + tag06;
							nextURL = nextURL + tag06;
						}
						if (tag07 != "") {
							tag07 = "+" + tag07;
							nextURL = nextURL + tag07;
						}
					} else if (tag02 != "") {
						nextURL = nextURL + tag02;
						if (tag03 != "") {
							tag03 = "+" + tag03;
							nextURL = nextURL + tag03;
						}
						if (tag04 != "") {
							tag04 = "+" + tag04;
							nextURL = nextURL + tag04;
						}
						if (tag05 != "") {
							tag05 = "+" + tag05;
							nextURL = nextURL + tag05;
						}
						if (tag06 != "") {
							tag06 = "+" + tag06;
							nextURL = nextURL + tag06;
						}
						if (tag07 != "") {
							tag07 = "+" + tag07;
							nextURL = nextURL + tag07;
						}
					} else if (tag03 != "") {
						nextURL = nextURL + tag03;
						if (tag04 != "") {
							tag04 = "+" + tag04;
							nextURL = nextURL + tag04;
						}
						if (tag05 != "") {
							tag05 = "+" + tag05;
							nextURL = nextURL + tag05;
						}
						if (tag06 != "") {
							tag06 = "+" + tag06;
							nextURL = nextURL + tag06;
						}
						if (tag07 != "") {
							tag07 = "+" + tag07;
							nextURL = nextURL + tag07;
						}
					} else if (tag04 != "") {
						nextURL = nextURL + tag04;
						if (tag05 != "") {
							tag05 = "+" + tag05;
							nextURL = nextURL + tag05;
						}
						if (tag06 != "") {
							tag06 = "+" + tag06;
							nextURL = nextURL + tag06;
						}
						if (tag07 != "") {
							tag07 = "+" + tag07;
							nextURL = nextURL + tag07;
						}
					} else if (tag05 != "") {
						nextURL = nextURL + tag05;
						if (tag06 != "") {
							tag06 = "+" + tag06;
							nextURL = nextURL + tag06;
						}
						if (tag07 != "") {
							tag07 = "+" + tag07;
							nextURL = nextURL + tag07;
						}
					} else if (tag06 != "") {
						nextURL = nextURL + tag06;
						if (tag07 != "") {
							tag07 = "+" + tag07;
							nextURL = nextURL + tag07;
						}
					} else if (tag07 != "") {
						nextURL = nextURL + tag07;

					} else {
						nextURL = "/collections/" + nowCat + "/";
					}
					//console.log("遷移先は"+nextURL);
					window.location.href = nextURL;

				};

			}

			//Sustainable
			if ($('body').hasClass('sustainable') || $('body').hasClass('restoration')) {
				let winWidth = $(window).width();
				let moviePC = $('#moviePC');
				let movieSP = $('#movieSP');
				if (winWidth < 768) {
					movieSP.attr('src', movieSP.data('src'));
					moviePC.hide();
					//console.log('SP');
				} else {
					moviePC.attr('src', moviePC.data('src'));
					movieSP.hide();
					//console.log('PC');
				}
			}
			if ($('body').hasClass('sustainable')) {
				//KVタテ幅設定
				let h = $(window).height();
				$('.pageSustainable__head').css({ 'height': h + 'px' });

				//iOS取得し、SDG'Sの背景設定
				const ua = navigator.userAgent
				if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
					$('.for-sdgs').addClass('iOS');
				}

			}

			//Restoration
			if ($('body').hasClass('restoration')) {

				//KVタテ幅設定
				let h = $(window).height();
				$('.restoration__movie').css({ 'height': h + 'px' });

				//STORY
				var sliderOpt = {
					infinite: true,
					arrows: true,
					dots: false,
					autoplay: false,
					slidesToShow: 2,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '20%',
					lazyLoad: 'progressive',
					prevArrow: '<div class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_detail_prev.png?v=1626080185" alt="PREV"></div>',
					nextArrow: '<div class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_detail_next.png?v=1626080185" alt"NEXT"></div>',
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							centerPadding: '6%'
						}
					}]
				};
				var slider = $('.storyList').slick(sliderOpt);

				slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
					$(".storyList .img").removeClass('is-open');
				});

				$('.aboutList a').click(function () {
					var href = $(this).attr("href");
					var target = $(href == "#" || href == "" ? 'html' : href);
					var position = target.offset().top;
					$("html, body").animate({ scrollTop: position }, 500);
					return false;
				});


				let winWidth = $(window).width();
				if (winWidth < 769) {
					$(this).off('hover');
					$(".storyList .img").click(function () {
						$(this).toggleClass('is-open');
					});
				}

			}

			//Coordinate
			if ($('body').hasClass('coordinate')) {
				var sliderOpt = {
					infinite: true,
					arrows: true,
					dots: false,
					autoplay: false,
					slidesToShow: 3,
					slidesToScroll: 1,
					lazyLoad: 'progressive',
					prevArrow: '<div class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_detail_prev.png?v=1626080185" alt="PREV"></div>',
					nextArrow: '<div class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_detail_next.png?v=1626080185" alt"NEXT"></div>',
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							centerMode: true,
							centerPadding: '18.6%'
						}
					}]
				};
				var slider = $('.pageCoordinate__slider').slick(sliderOpt);
				
				//popup
				$('.pageCoordinate__slider').magnificPopup({
					delegate: 'li:not(.slick-cloned) a',
					type: 'image',
					gallery: { //ギャラリー表示にする
						enabled: true
					},
					removalDelay: 500, //delay removal アウトする際のアニメーションの遅延
					callbacks: {
						beforeOpen: function () {
							// mfp-with-anim クラスをマークアップに追加 
							this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
							this.st.mainClass = this.st.el.attr('data-effect');
						}
					},
					closeOnContentClick: true,
					midClick: true, // allow opening popup on middle mouse click. 
					preload: [1,18]
				});

			}

			//pagetop
			$('.scrollUp a').click(function () {
				var href = $(this).attr("href");
				var target = $(href == "#" || href == "" ? 'html' : href);
				var position = target.offset().top;
				$("html, body").animate({ scrollTop: position }, 500);
				return false;
			});
		});

		var spW = 768, // SP max width, not contain
			isSp, // Is SP or not
			winW, // Window width
			winH, // Window height
			winST, // Window scrollTop
			isChange; // Is change to PC/SP

		$(function () {
			initCommon();

			if ($('.pick ul').length) $('.pick').data('imgLen', $('.pick ul img').length);
			initPickSlider();

			$(window).scroll(function () {
				setFadeBanner();
				//stepFadeIn($('.pick'), $('.pick ul img'));
			}).trigger('scroll');

			//Gナビ
			$('.toggleNav').hover(function () {

				//ヘッダーに背景追加
				$('.header-wrapper').addClass('is-active');
				//ヘッダーアイコンの色変更
				$('#shopify-section-head-icon, #btnMenu').addClass('background--light');
				//サブナビを表示
				//$(this).find('.targetNav').stop().fadeIn(800, function () {
				//	if (!$('.header-wrapper').hasClass('is-active')) {

				//		$('.header-wrapper').addClass('is-active');
				//		$('#shopify-section-head-icon, #btnMenu').addClass('background--light');
				//	}
				$(this).find('.targetNav').addClass('is-active');

				//});
			}, function () {

				//$(this).find('.targetNav').stop().fadeOut(800);
				$(this).find('.targetNav').removeClass('is-active');
				$('.header-wrapper').removeClass('is-active');
				$('#shopify-section-head-icon, #btnMenu').removeClass('background--light');

			});

			//SPナビ アコーディオン
			$('.moList01__list .toggle').click(function () {
				$(this).toggleClass('is-open').parent().parent().next().slideToggle(250);
			});

		});



		function initCommon() {

			$(window).on('load', function () {
				$('#cover').fadeOut(800);
				initBackgrounCheck();

				setTimeout(function () {
					$('body').addClass('loaded');
					BackgroundCheck.refresh();
				}, isSp ? 0 : 800);
				initLazyload();
				setFadeInUp();

				/* if (isiPad) $('body').addClass('iPad');
				initHeaderFavorite(); */
				//header faiv
			});


			$(window).on('scroll', function () {
				winST = $(window).scrollTop();
				setFadeInUp();
			}).trigger('scroll');

			$(window).on('resize', function () {
				getWinSize();
				//setMenuScroll();
				setFadeInUp();

				/* if (isChange) {
					initMenu();
				} */
			}).trigger('resize');
		}

		function getWinSize() {
			winW = $('html').css('overflow', 'hidden').width();
			winH = $(window).height();
			isChange = isSp !== undefined && isSp != (winW < spW);
			isSp = winW < spW;
			$('html').removeAttr('style');
		}

		//lazy
		function initLazyload() {
			if (!$('img.lazy').length) return;
			$('img.lazy').lazyload({
				threshold: 1,
				effect: 'fadeIn',
				effect_speed: 500,
				failure_limit: 1,
				placeholder: 'https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_space.png'
			});
		}


		//Fade
		function setFadeInUp() {
			var fadeObj = $('.fadeInUp');
			if (!fadeObj.length) return;
			var delayH = 80;

			fadeObj.each(function () {
				var elm = $(this),
					elmT = elm.offset().top,
					elmH = elm.height();

				if (winST > elmT - winH + delayH && winST < elmT + elmH) {
					elm.addClass('animated');
				} else if (winST < elmT - winH + delayH && winST < elmT + delayH) {
					elm.removeClass('animated');
				}
			});
		}

		function stepFadeIn(container, item) {
			if (!container.length) return;

			var delayH = 40;
			var duration = 2;
			var delay = .1;
			var top = container.offset().top;

			if (container.data('fadeFlag') == undefined) TweenLite.to(item, 0, { opacity: 0 });

			if (!container.data('loadFlag')) {
				if (winST > top - winH - 500) {
					item.each(function () {
						$(this).attr('src', $(this).data('original'));
					}).load(function () {
						container.data('imgLen', container.data('imgLen') - 1);
						if (!container.data('imgLen')) {
							container.data('loadFlag', true);
							$(window).trigger('scroll');
						}
					});
				}
			} else {
				if (winST > top - winH + delayH || top <= winH) {
					if (container.data('fadeFlag')) return;
					item.each(function (i) {
						var num = ($(this).data('index') != undefined) ? $(this).data('index') : i;
						TweenLite.to($(this), duration, { opacity: 1, delay: (isSp && container.data('spnostep')) ? 0 : (delay * num) });
					});
					container.data('fadeFlag', true);
				}
			}
		}

		function initBackgrounCheck() {
			BackgroundCheck.init({
				targets: '#btnMenu' + ($('#shopify-section-head-icon').length ? ', #shopify-section-head-icon' : ''),
				images: '.backgroundCheck'
			});
		}

		function setFadeBanner() {
			$('.banner').each(function () {
				if (!$(this).find('h2').length) return;
				if (winST > $('.banner').height() + 100) {
					$('.banner').stop().animate({ opacity: 0 }, 25);
				} else {
					$('.banner').stop().animate({ opacity: 1 }, 25);
				}
			});
		}

		function initPickSlider() {
			if (!$('.pick ul').length) return;
			if ($('.pick ul').hasClass('slick-slider')) {
				$('.pick ul').slick('unslick');
			}

			if ($('.pickup').length && !$('body').hasClass('pickup')) {

				//slider
				var pickupSliderOpt = {
					infinite: true,
					arrows: true,
					dots: false,
					autoplay: false,
					slidesToShow: 5,
					slidesToScroll: 5,
					lazyLoad: 'progressive',
					prevArrow: '<div class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_packup_arrow_01.png?v=1627377578" alt="PREV"></div>',
					nextArrow: '<div class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0580/4775/8485/files/img_packup_arrow_02.png?v=1627377578" alt"NEXT"></div>',
					responsive: [{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							centerMode: true,
							centerPadding: '50px'
						}
					}]
				};
				var pickupSlider = $('.pickup__list').slick(pickupSliderOpt);
			}

		}

		$(document).ready(function() {
	// ボタンの骨格HTMLを.bannerに追加
	var buttonHtml = '<a href="/pages/intersection" class="slider-button">More</a>';
	$('.banner').append(buttonHtml);

	// スライド切り替え時の処理
	$(window).on("backstretch.after", function (e, instance, index) {
		var sliderButton = $('.slider-button');
		if (sliderButton.length > 0) {
		if (index >= 3) { // 1枚目のスライド(0)・2枚めのスライド(1）・3枚めのスライド(2）
			sliderButton.addClass('is-visible'); // 表示クラスを追加
		} else { // それ以外なら
			sliderButton.removeClass('is-visible'); // 表示クラスを削除
		}
		}
	});

	// ページ読み込み時に初回イベントを実行
	if ($.backstretch) {
		try {
		$(window).trigger("backstretch.after", [$.backstretch('instance'), 0]);
		} catch(e) { /* エラー処理 */ }
	}
	});